// src/utils/usStates.ts
/** Valid US state two-letter abbreviations (50 states). */
const US_STATE_CODES = /* @__PURE__ */ new Set([
	"AL",
	"AK",
	"AZ",
	"AR",
	"CA",
	"CO",
	"CT",
	"DE",
	"FL",
	"GA",
	"HI",
	"ID",
	"IL",
	"IN",
	"IA",
	"KS",
	"KY",
	"LA",
	"ME",
	"MD",
	"MA",
	"MI",
	"MN",
	"MS",
	"MO",
	"MT",
	"NE",
	"NV",
	"NH",
	"NJ",
	"NM",
	"NY",
	"NC",
	"ND",
	"OH",
	"OK",
	"OR",
	"PA",
	"RI",
	"SC",
	"SD",
	"TN",
	"TX",
	"UT",
	"VT",
	"VA",
	"WA",
	"WV",
	"WI",
	"WY"
]);
function isUsStateCode(code) {
	return US_STATE_CODES.has(code.toUpperCase());
}
const LOWERCASE_STATE_NAME_TO_ABBREVIATION = Object.entries({
	Alabama: "AL",
	Alaska: "AK",
	Arizona: "AZ",
	Arkansas: "AR",
	California: "CA",
	Colorado: "CO",
	Connecticut: "CT",
	Delaware: "DE",
	Florida: "FL",
	Georgia: "GA",
	Hawaii: "HI",
	Idaho: "ID",
	Illinois: "IL",
	Indiana: "IN",
	Iowa: "IA",
	Kansas: "KS",
	Kentucky: "KY",
	Louisiana: "LA",
	Maine: "ME",
	Maryland: "MD",
	Massachusetts: "MA",
	Michigan: "MI",
	Minnesota: "MN",
	Mississippi: "MS",
	Missouri: "MO",
	Montana: "MT",
	Nebraska: "NE",
	Nevada: "NV",
	"New Hampshire": "NH",
	"New Jersey": "NJ",
	"New Mexico": "NM",
	"New York": "NY",
	"North Carolina": "NC",
	"North Dakota": "ND",
	Ohio: "OH",
	Oklahoma: "OK",
	Oregon: "OR",
	Pennsylvania: "PA",
	"Rhode Island": "RI",
	"South Carolina": "SC",
	"South Dakota": "SD",
	Tennessee: "TN",
	Texas: "TX",
	Utah: "UT",
	Vermont: "VT",
	Virginia: "VA",
	Washington: "WA",
	"West Virginia": "WV",
	Wisconsin: "WI",
	Wyoming: "WY"
}).reduce((acc, [name, abbr]) => {
	acc[name.toLowerCase()] = abbr;
	return acc;
}, {});
/**
* Resolves a US state two-letter code from a full name or abbreviation.
* Returns null when input is missing or unrecognized.
*/
function toUsStateCode(state) {
	const trimmed = state?.trim().toLowerCase();
	if (!trimmed) return null;
	if (trimmed.length === 2) {
		const code = trimmed.toUpperCase();
		return isUsStateCode(code) ? code : null;
	}
	return LOWERCASE_STATE_NAME_TO_ABBREVIATION[trimmed] ?? null;
}
/** Normalize stored state codes (uppercase, unique, sorted). */
function normalizeStateCodes(codes) {
	return [...new Set(codes.map((code) => code.trim().toUpperCase()).filter(Boolean))].sort();
}
function refineManualLicensedStates(codes, ctx, pathPrefix = ["manualLicensedStates"]) {
	for (let i = 0; i < codes.length; i++) if (!isUsStateCode(codes[i])) ctx.addIssue({
		code: "custom",
		message: `Invalid US state code: ${codes[i]}`,
		path: [...pathPrefix, i]
	});
}
function refineApprovedForConsultsRequiresStates(data, ctx) {
	if (data.approvedForConsults && data.manualLicensedStates.length === 0) ctx.addIssue({
		code: "custom",
		message: "approvedForConsults requires at least one entry in manualLicensedStates",
		path: ["approvedForConsults"]
	});
}

export { US_STATE_CODES, isUsStateCode, normalizeStateCodes, refineApprovedForConsultsRequiresStates, refineManualLicensedStates, toUsStateCode };
//# sourceMappingURL=usStates.mjs.map